// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2aSzC","right":"Footer_right__2YaCl","buttons":"Footer_buttons__2B7eU"};